import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core"
import ButtonRounded from "components/Common/ButtonRounded"
import ConditionalDialogWrapper from "components/Common/ConditionalDialogWrapper"
import AppContext from "contexts/App"
import { useContext } from "react"
import copy from "utils/copy"

import useStyles from "./styles"

const WidgetEmbedTool = () => {
  const classes = useStyles()

  const { dialogs, closeDialog, authUser, openSnackBar, token } =
    useContext(AppContext)
  const thisDialog = dialogs?.["widgetEmbedTool"] || {}
  const { open = false, data = {} } = thisDialog

  const handleClose = () => {
    closeDialog("widgetEmbedTool")
  }

  const copyText = () => {
    copy(text())
    openSnackBar({ message: "Iframe code copied" })
  }

  const text = () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return `<iframe width="100%" height="500" src="https://localhost:3000/clerk/pub?e=${authUser?.entity_id}"></iframe>`
    } else if (process.env.REACT_APP_NODE_ENV === "staging") {
      return `<iframe width="100%" height="500" src="https://app.matchboard.dev/pub?e=${authUser?.entity_id}"></iframe>`
    } else {
      return `<iframe width="100%" height="500" src="https://app.matchboard.tech/pub?e=${authUser?.entity_id}"></iframe>`
    }
  }
  return (
    <ConditionalDialogWrapper
      open={open}
      onClose={handleClose}
      newClasses={{ paper: classes.paper }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h2">Widget Embed Tool</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.subtitle}
        >
          How to use it:
        </Typography>
        <Typography variant="subtitle1" className={classes.explanation}>
          This tool will embed all board positions on your entity website. Copy
          the snippet below and embed it on a new web page
        </Typography>
        <Box className={classes.codeBox}>
          <Typography className={classes.code}>{text()}</Typography>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          <ButtonRounded
            className={classes.copyButton}
            onClick={copyText}
            type="button"
            variant="contained"
            color="primary"
          >
            Copy Snippet
          </ButtonRounded>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <ButtonRounded
            onClick={handleClose}
            type="button"
            className={classes.closeButton}
          >
            Close
          </ButtonRounded>
        </Box>
      </DialogActions>
    </ConditionalDialogWrapper>
  )
}

export default WidgetEmbedTool
